module.exports = __webpack_public_path__ + "img/schoolforlife.bd5e444.jpg";